import { HttpClientXsrfModule } from '@angular/common/http';
import {
  ErrorHandler,
  NgModule,
  NgModuleFactoryLoader,
  PLATFORM_ID,
  SystemJsNgModuleLoader,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ABTestModule } from '@freelancer/abtest';
import { AuthModule } from '@freelancer/auth';
import {
  datastoreActionSanitizer,
  DatastoreModule,
} from '@freelancer/datastore';
import {
  FreelancerHttp,
  FreelancerHttpModule,
} from '@freelancer/freelancer-http';
import { ThreatmetrixModule } from '@freelancer/threatmetrix';
import { TimeUtilsModule } from '@freelancer/time-utils';
import { CustomErrorHandler, TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { CookieModule, COOKIE_OPTIONS } from '@laurentgoudet/ngx-cookie';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ActionSanitizer } from '@ngrx/store-devtools/src/config';
import { environment } from '../environments/environment';
import { AppModalsModule } from './app-modals.module';
import { AuthGuard } from './auth-guard.service';
import { cookieOptionsFactory } from './cookie-options.factory';

/* The type for ActionSanitizer doesn't allow a custom action type.
  * ActionSanitizer probably should be
  *  export declare type ActionSanitizer<A extends Action = Action> = (
  *    action: A,
  *    id: number,
  *  ) => A;
  * but it isn't so let's cast through `any` for now.
  */
const actionSanitizer: ActionSanitizer = datastoreActionSanitizer as any;

// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'webapp' }),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientXsrfModule.disable(), // no part of the app should rely on that
    AppModalsModule,
    UiModule.initialize(environment.uiConfig),
    AuthModule.initialize(environment.authConfig),
    CookieModule.forRoot(),
    ThreatmetrixModule.initialize(environment.threatmetrixConfig),
    FreelancerHttpModule.initialize(environment.freelancerHttpConfig),
    DatastoreModule.initialize({
      webSocketUrl: environment.datastoreConfig.webSocketUrl,
      enableStoreFreeze: environment.datastoreConfig.enableStoreFreeze,
      httpAdapter: FreelancerHttp,
      requestData: {},
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 150,
          actionSanitizer,
        })
      : [],
    TrackingModule.initialize(environment.trackingConfig),
    ABTestModule.initialize(),
    TimeUtilsModule,
  ],
  providers: [
    AuthGuard,
    Title,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    {
      provide: COOKIE_OPTIONS,
      deps: [PLATFORM_ID],
      useFactory: cookieOptionsFactory,
    },
    { provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader },
  ],
  exports: [BrowserModule, TrackingModule, UiModule],
})
export class AppCommonModule {}
